export default __webpack_public_path__ + "03e3c10d4a52fe7b56918f851766d886.woff2";